import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs";
import { ConfigService } from "src/app/core/config.service";
import { ImpervaChartsData, ImpervaResourceDetails, ImpervaResources } from "./imperva-resources.model";
import {ImpervaResourceTypeEnum} from "src/app/shared/enum/imperva-resource-type.enum";

@Injectable({
    providedIn: 'root'
})
export class ImpervaResourcesService {

    constructor(private httpClient: HttpClient, private configService: ConfigService) {}

    loadImpervaResources(accountId: string){
        return this.httpClient.get<ImpervaResources>(`${this.configService.config.apiUrl}/iac/resources/imperva?account=${accountId}`)
        .pipe(
            map((response=>{
                const data: any[] = []
                const impervaEnumKeys = Object.keys(ImpervaResourceTypeEnum);
                for(let type in response){
                    const resources = response[type as keyof ImpervaResources]
                    if(impervaEnumKeys.includes(type)){
                        data.push(...resources.checked.map((value) => {return {...value, type: type}}))
                        data.push(...resources.unchecked.map((value) => {return {...value, type: type}}))
                        data.push(...resources.ignored.map((value) => {return {...value, type: type}}))
                    }
                }
                return data
            }))
        )
    }

    loadImpervaResourceDetails(accountId: string, resourceId: string){
        return this.httpClient.get<ImpervaResourceDetails>(`${this.configService.config.apiUrl}/iac/resources/imperva/details?account=${accountId}&resource_id=${resourceId}`)
    }

    loadImpervaMeasures(accountId: string, start_date: string, end_date: string, granularity: string){
        return this.httpClient.get<ImpervaChartsData>(`${this.configService.config.apiUrl}/iac/resources/imperva/measures?account=${accountId}&start_date=${start_date}&end_date=${end_date}&granularity=${granularity}`)
    }
}
